"use strict";

// Varible setup
// ========================
var popup_links, popup_outer, popup_inner, popup_close;

// Main function
// ========================
function setupPopup() {
	popup_links = document.querySelectorAll("[href='#buildertrend-login']");
	popup_outer = document.getElementById("popup-outer");
	popup_inner = document.getElementById("popup-inner");
	popup_close = document.getElementById("popup-close");

	for(var i=0; i<popup_links.length; i++) {
		popup_links[i].addEventListener("click", openPopup, false);
	}

	// Prevent clicks on popup-inner from triggering an event for popup-outer.
	popup_inner.addEventListener("click", function(event) {
		event.stopPropagation();
	});

	popup_close.addEventListener("click", closePopup, false);
	popup_outer.addEventListener("click", closePopup, false);
}


// Helper functions
// ========================
function openPopup() {
	popup_outer.classList.add("is-visible");
}

function closePopup(event) {
	if ( event.target.id == "popup-close" ) {
		event.stopPropagation();
	}
	popup_outer.classList.remove("is-visible");
}


// Listeners
// ========================

// I used DOMContentLoaded because it allows the page to be interactive as soon as it's visible.
window.addEventListener("DOMContentLoaded", setupPopup);
